import { render } from "./BottleNew.vue?vue&type=template&id=58ed47d5&scoped=true"
import script from "./BottleNew.vue?vue&type=script&lang=js"
export * from "./BottleNew.vue?vue&type=script&lang=js"

import "./BottleNew.vue?vue&type=style&index=0&id=58ed47d5&scoped=true&lang=css"

import exportComponent from "/usr/src/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-58ed47d5"]])

export default __exports__